var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block-header"},[_c('div',[_vm._v(" "+_vm._s(_vm.label)+": "+_vm._s(_vm.value || '-')+" ")]),_c('div',{staticClass:"content-block-header__right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }